'use strict'

import angular from 'angular'
import ListController from './list.controller'

export default angular.module('updateServerApp.devices.list', [])
  .controller('DevicesListController', ListController)
  .name



// WEBPACK FOOTER //
// ./client/app/devices/list/index.js